import styled from "styled-components";

const StyledOnDemand = styled.div`
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        .custom-picker-range-popup-resposive{
            position: absolute !important;
            top: 100% !important;
            left: 0 !important;
            right: 0 !important;
            transform: none !important;
            margin-top: 8px !important;
            width: 100vw !important;
            max-width: 100% !important;
            min-width: 100% !important;
            z-index: 9999 !important;
        }
    }

    .sb-on-demand-container {
        &__body {
            &__head {
                &__range-picker {
                    position: relative;
                }
            }
            &__filters {
                .search-input {
                    height: 48px;
                }
                @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
                    .ant-picker-range {
                        width: 100%
                    }                
                }

            }
        }
    }
`;

export default StyledOnDemand;
